/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from '@solana/kit';

export type VestingSchedule = { cliffSeconds: bigint; durationSeconds: bigint };

export type VestingScheduleArgs = {
  cliffSeconds: number | bigint;
  durationSeconds: number | bigint;
};

export function getVestingScheduleEncoder(): FixedSizeEncoder<VestingScheduleArgs> {
  return getStructEncoder([
    ['cliffSeconds', getU64Encoder()],
    ['durationSeconds', getU64Encoder()],
  ]);
}

export function getVestingScheduleDecoder(): FixedSizeDecoder<VestingSchedule> {
  return getStructDecoder([
    ['cliffSeconds', getU64Decoder()],
    ['durationSeconds', getU64Decoder()],
  ]);
}

export function getVestingScheduleCodec(): FixedSizeCodec<
  VestingScheduleArgs,
  VestingSchedule
> {
  return combineCodec(getVestingScheduleEncoder(), getVestingScheduleDecoder());
}
